import { Collapse, Grid, IconButton, ListItem } from "@material-ui/core";
import { SnackbarContent, ListItemText, List, Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";

// Icons
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { Close, ErrorOutlineRounded } from "@material-ui/icons";

const ErrorMessages = ({ openSnacError, setOpenSnacError, errors, errorAlertTitle, classes, closeErrorMessages }) => {
	const { t } = useTranslation();
	const isMultiple = errors?.length > 1;

	const handleErrorList = () => {
		setOpenSnacError(!openSnacError);
	};

	return (
		<SnackbarContent
			className={classes.errorMessage}
			role="alert"
			aria-live="assertive"
			message={
				<Grid>
					<Grid>
						<List className={`${classes.errorList} p-0 m-0`}>
							<ListItem className={`${classes.justify} p-1 m-0`}>
								<span className="d-flex flex-column w-100 align-items-start">
									<Box className="d-flex px-2 w-100">
										<ErrorOutlineRounded className={classes.errorIcon} />
										<ListItemText primary={errorAlertTitle} className={classes.errorList_2} />
										<Grid>
											<span className={classes.justify}>
												<IconButton
													aria-label={t("alerts.dismissErrors")}
													onClick={closeErrorMessages}
													className="m-0 p-1"
												>
													<Close className={classes.errorIcon} />
												</IconButton>
											</span>
										</Grid>
									</Box>
									<Box className="d-flex px-2 w-100">
										<ListItemText
											className={classes.errorList_3}
											primary={
												isMultiple
													? errorAlertTitle
													: errors.map((error) => t(error) || error).join(", ")
											}
										/>
									</Box>
								</span>
							</ListItem>
							{isMultiple && (
								<ListItem onClick={handleErrorList} className={classes.justify}>
									<span className="d-flex flex-column mt-1 w-100 align-items-end">
										{openSnacError ? <ExpandLess /> : <ExpandMore />}
										<span className="d-flex flex-column w-100 align-items-start">
											{errors?.map((error) => (
												<Collapse in={openSnacError} timeout="auto" unmountOnExit>
													<Box className="d-flex py-2">
														<ErrorOutlineRounded className={`${classes.errorIcon} mx-2`} />
														{t(error) || error}
														<br />
													</Box>
												</Collapse>
											))}
										</span>
									</span>
								</ListItem>
							)}
						</List>
					</Grid>
				</Grid>
			}
		/>
	);
};

export default ErrorMessages;
